import { api, unwrap } from "@/lib/api";

export type AdminReviewStatus = "PENDING" | "APPROVED" | "REJECTED";

export interface AdminReviewProduct {
	id: string;
	sku: string;
	title: string;
	slug: string;
}

export interface AdminReviewCustomer {
	id: string;
	firstName: string;
	lastName: string | null;
	email: string;
}

export interface AdminReviewItem {
	id: string;
	productId: string;
	customerId: string;
	rating: number;
	title: string | null;
	comment: string | null;
	status: AdminReviewStatus;
	isVerifiedPurchase: boolean;
	moderatedAt: string | null;
	rejectionReason: string | null;
	createdAt: string;
	updatedAt: string;
	product?: AdminReviewProduct;
	customer?: AdminReviewCustomer;
}

export interface AdminReviewsStats {
	pending: number;
	approved: number;
	rejected: number;
	total: number;
}

export interface AdminReviewsListResponse {
	data: AdminReviewItem[];
	total: number;
	page: number;
	pageSize: number;
	stats: AdminReviewsStats;
}

export interface AdminReviewsQuery {
	page?: number;
	pageSize?: number;
	status?: AdminReviewStatus;
	productId?: string;
	search?: string;
}

export const reviewsApi = {
	list: (params: AdminReviewsQuery = {}): Promise<AdminReviewsListResponse> =>
		unwrap(api.get("/admin/reviews", { params })),

	approve: (id: string): Promise<AdminReviewItem> =>
		unwrap(api.patch(`/admin/reviews/${id}/approve`)),

	reject: (id: string, reason?: string): Promise<AdminReviewItem> =>
		unwrap(api.patch(`/admin/reviews/${id}/reject`, { reason })),

	delete: (id: string): Promise<{ success: boolean }> =>
		unwrap(api.delete(`/admin/reviews/${id}`)),
};
